import { makeStyles } from '@material-ui/styles'
import { Theme } from 'styling/theme'

export default makeStyles((theme: Theme) => ({
    box: {
        alignItems: 'center',
        display: 'flex',
        '@media (max-width: 767px)': {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
        },
        '&:hover': {
            cursor: 'pointer',
        },
    },
    info: {
        marginLeft: 48,
        '& > *': {
            color: theme.colors.white,
            marginBottom: 16,
        },
        '& > h1': {
            fontSize: 40,
            color: theme.fontColors.light.color,
            fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        },
        '& > h2': {
            fontSize: 24,
            fontStyle: 'normal',
            color: theme.fontColors.light.color,
            fontFamily: theme.typographyPresets.fonts.monserrat.regular,
            fontWeight: 500,
            opacity: 0.8,
        },
        '& > h3': {
            fontSize: 18,
            fontStyle: 'normal',
            color: theme.fontColors.light.color,
            fontFamily: theme.typographyPresets.fonts.monserrat.light,
            opacity: 0.6,
        },
        '& > p': {
            marginTop: 16,
            textDecoration: 'underline',
            fontSize: 20,
            fontFamily: theme.typographyPresets.fonts.monserrat.regular,
            fontWeight: 600,
            color: '#ffc908',
        },
        '@media (max-width: 767px)': {
            width: '100%',
            marginLeft: 0,
            position: 'relative',
            bottom: 30,
            '& > h1': {
                fontSize: 24,
            },
            '& > h2': {
                fontSize: 16,
            },
            '& > h3': {
                fontSize: 14,
            },
            '& > p': {
                fontSize: 14,
            },
        },
    },
}))
